// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payment-form-preloader[data-v-f29f2a3a]{display:flex;flex-direction:column;width:100%;--tw-bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--tw-bg-opacity));padding:1.5rem}@media (min-width:768px){.payment-form-preloader[data-v-f29f2a3a]{padding-left:2.5rem;padding-right:2.5rem}}@media (min-width:1024px){.payment-form-preloader[data-v-f29f2a3a]{border-radius:.75rem;padding:2rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
